<script setup>
defineProps({
    type: {
        type: String,
        default: 'submit',
    },
})
</script>

<template>
    <button
        :type="type"
        class="inline-flex w-fit cursor-pointer rounded-xl bg-gray-100 px-3.5 py-2.5 text-center text-sm font-semibold shadow-xs hover:bg-gray-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-500 transition-all"
    >
        <slot />
    </button>
</template>
